import AbstractWidget from "@/models/PlatinumWidget/AbstractWidget";
import PlatinumWidget from "@/models/PlatinumWidget/PlatinumWidget";
import MediaLibraryItem from "@/models/Media/Library/Item/MediaLibraryItem";

export default class Video extends AbstractWidget {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'platinum-widget/video';

    /**
     *
     * @type {string}
     */
    static entity = 'platinumWidgetVideos';

    static model_name = 'Video';

    static fields() {
        return {
            id: this.number(null).nullable(),
            media_library_item_id: this.number(null),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            widget: this.hasOne(PlatinumWidget, 'widgetable_id'),
            mediaLibraryItem: this.hasOne(MediaLibraryItem, 'id', 'media_library_item_id'),
        }
    }

    Widget() {
        return PlatinumWidget.byWidgetable(this.WidgetTemplate().key, this.id);
    }
}
